<div class="layout-container"
  [ngClass]="{ 'navbar-collapsed': shared.sidebarOpened(), 'comparison-mode': isComparisonLink(), 'maf-mode': isMafRoute() }">
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav *ngIf="!isComparisonLink() && !isMafRoute()" mode="side" [opened]="true"
      class="left-sidebar broker-nav" [ngClass]="{ 'collapsed': shared.sidebarOpened() }">
      <div class="sidebar-header">
        <img *ngIf="!shared.sidebarOpened()" [src]="images.broker_sidebar_large" [alt]="'NAV.LOGO'" class="brand-logo" />
        <img *ngIf="shared.sidebarOpened()" [src]="images.broker_sidebar_small" [alt]="'NAV.LOGO'" />
      </div>
      <mat-nav-list
        [ngClass]="{ 'broker-list-collapsed': shared.sidebarOpened(),'broker-list': !shared.sidebarOpened()}">
        <div class="nav-list-top">
          <a mat-list-item *ngFor="let item of topNavItems(); let i = index" [routerLink]="item.routerLink"
            (click)="onTopNavSelect(i)" [ngClass]="{'active-nav-item': selectedTopNavIndex() === i}">
            <mat-icon matListItemIcon [svgIcon]="item.icon"></mat-icon>
            <span matListItemTitle *ngIf="!shared.sidebarOpened()">
              {{ item.title | i18nTranslate }}
            </span>
          </a>
        </div>
        <div class="nav-list-bottom">
          <ng-container *ngFor="let item of bottomNavItems()">
            <button *ngIf="item.icon === 'logout'; else bottomNavLink" mat-list-item type="button"
              class="bottom-nav-action" (click)="onLogoutClick($event)">
              <mat-icon matListItemIcon fontSet="material-icons-outlined" class="logout">logout</mat-icon>
              <span matListItemTitle *ngIf="!shared.sidebarOpened()">
                {{ item.title | i18nTranslate }}
              </span>
            </button>

            <ng-template #bottomNavLink>
              <a mat-list-item [routerLink]="item.routerLink">
                <mat-icon matListItemIcon fontSet="material-icons-outlined">{{ item.icon }}</mat-icon>
                <span matListItemTitle *ngIf="!shared.sidebarOpened()">
                  {{ item.title | i18nTranslate }}
                </span>
              </a>
            </ng-template>
          </ng-container>
        </div>
      </mat-nav-list>
      <div class="sidebar-footer">
        <img *ngIf="!shared.sidebarOpened()" [src]="images.InsureLiv_Logo" [alt]="'NAV.LOGO'"
          class="footer-brand-logo" />
        <div class="powered-by" *ngIf="!shared.sidebarOpened()">
          <span class="poweredBy-text"> {{ "NAV.PRODUCT_SUBTITLE" | i18nTranslate }} </span>
          <strong class="poweredBy-text"> {{ "NAV.PRODUCT_COMPANY" | i18nTranslate }} </strong>
          <!-- <img [src]="images.WB_logo" alt="WhiteBlue Logo" class="wb-logo" /> -->
        </div>
        <div class="powered-by" *ngIf="shared.sidebarOpened()">
          <mat-icon class="wb-only-logo" *ngIf="shared.sidebarOpened()" svgIcon="il_logo_only"></mat-icon>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content class="content">
      <app-global-header [ngClass]="{ 'comparison-header-gap': isComparisonLink() }"
        [headerTitle]="headerTitle | i18nTranslate" [showBackButton]="showGlobalBackButton()"
        [hideToggleAndNotification]="isComparisonLink() || isMafRoute()"
        [unsavedChangesDialogConfig]="headerUnsavedChangesDialogConfig"
        [activeInsuranceProduct]="isMotorRoute() ? 'motor' : 'medical'"
        [showInsuranceProductSwitch]="showInsuranceProductSwitch()"
        [selectedProductName]="(selectedProduct()?.headerNameKey ?? selectedProduct()?.nameKey) | i18nTranslate"
        [selectedProductIcon]="selectedProduct()?.headerIcon ?? null"
        [source]="isMafRoute() ? 'maf' : isComparisonLink() ? 'comparison' : ''"
        (globalSearchChange)="onGlobalSearch($event)" (backButtonClick)="onBackButtonClick()"
        (insuranceProductChange)="onInsuranceProductChange($event)"
        (profileClick)="onProfileIconClick()">
      </app-global-header>
      <ng-content></ng-content>
    </mat-sidenav-content>

    <!-- Profile drawer: overlay mode with backdrop -->
    <mat-sidenav *ngIf="quoteDrawerService.rightDrawerMode() === 'profile' || isProfileDrawerClosing" mode="over"
      position="end" [opened]="quoteDrawerService.rightDrawerOpened()" class="right-sidebar right-sidebar--profile"
      [disableClose]="true" (closedStart)="onProfileAnimationStart()">
      <app-view-user-details [showMore]="true" [userId]="quoteDrawerService.profileDrawerUser()?.id ?? null"
        [user]="quoteDrawerService.profileDrawerUser()" (closeDrawer)="onProfileDrawerClose()">
      </app-view-user-details>
    </mat-sidenav>

    <!-- Quote drawer: side mode (pushes content) -->
    <mat-sidenav *ngIf="shouldShowRightDrawer() && quoteDrawerService.rightDrawerMode() === 'quote'" mode="side"
      position="end" [opened]="quoteDrawerService.rightDrawerOpened()" class="right-sidebar">
      <app-quote-drawer [isComparison]="isComparisonLink()"></app-quote-drawer>
    </mat-sidenav>

    <!-- Audit Trail Side Panel -->
    <mat-sidenav #auditDrawer *ngIf="shouldShowRightDrawer() && quoteDrawerService.rightDrawerMode() === 'audit'"
      mode="side" position="end" [opened]="quoteDrawerService.rightDrawerOpened()"
      class="right-sidebar right-sidebar--profile">
      <app-audit-details-panel [auditDetails]="quoteDrawerService.auditDrawerData()"></app-audit-details-panel>
    </mat-sidenav>

  </mat-sidenav-container>

  <mat-icon
    *ngIf="quoteDrawerService.rightDrawerMode() === 'quote' && !isMafRoute() && !quoteDrawerService.mobileCompareActive()"
    class="drawer-close left" [svgIcon]="isDrawerOpen() ? 'icon-drawer-bg-minus' : 'icon-drawer-bg-menu'"
    (click)="toggleSideBar()">
  </mat-icon>



  <!-- <button mat-icon-button class="profile-btn">
    <mat-icon>account_circle</mat-icon>
  </button> -->


  <div class="toggle-wrapper">
    <!-- <button
      mat-icon-button
      (click)="toggleMenu()"
      class="sidebar-toggle-btn"
    >
      <mat-icon
        class="background-icon"
        svgIcon="icon-sidebar-toggle"
      ></mat-icon>
      <mat-icon class="foreground-icon">{{
        shared.sidebarOpened() ? "keyboard_double_arrow_right" : "keyboard_double_arrow_left"
      }}</mat-icon>
    </button> -->
  </div>
</div>
